import { useCurrentRole, useCurrentUserEmail, useIsAdmin } from "../api/auth.js";
import {
  prefersSharePointCoEdit,
  useCreateWorkspaceDocument,
  useSharePointConfig,
  useUploadSharePointVersion,
  useUploadWorkspaceVersion,
  useWorkspaceCollaborationSites,
  useWorkspaceDocumentEditUrl,
  useWorkspaceDocuments,
  useWorkspaceFolders,
  useWorkspaces,
} from "../api/workspaces.js";
import { AskInsightsDrawer } from "../components/ai/AskInsightsDrawer.js";

import type { BoardHubServices } from "@l30/web-board/host";

/**
 * Hub-side implementation of the `BoardHubServices` port (ADR-0101 Phase 5b).
 *
 * `@l30/web-board` must not import `packages/web/src/**`, so every
 * cross-domain hook/component it needs (auth, workspaces, Ask Insights)
 * is proxied through this factory and injected via `<BoardHubProvider>`
 * (mounted in `_authenticated.tsx`).
 */
export function createBoardHubServices(): BoardHubServices {
  return {
    useCurrentRole,
    useCurrentUserEmail,
    useIsAdmin,

    AskInsightsDrawer,

    prefersSharePointCoEdit,
    useWorkspaces,
    useWorkspaceFolders,
    useWorkspaceDocuments,
    useCreateWorkspaceDocument,
    useUploadWorkspaceVersion,
    useUploadSharePointVersion,
    useWorkspaceDocumentEditUrl,
    useWorkspaceCollaborationSites,
    useSharePointConfig,
  };
}
